/**
 * Legal copy for subscription flow.
 * Design: Figma Trashie 2.0 node 6185:9611, footer 6185:9622
 */

import { MEMBERSHIP_TERMS_URL } from '../../../config/externalURL';

import './SubscriptionLegal.scss';

const SubscriptionLegal = () => (
  <section className="SubscriptionLegal" aria-labelledby="subscription-legal-heading">
    <div className="SubscriptionLegal__container">
      <h2 id="subscription-legal-heading" className="SubscriptionLegal__heading">
        Membership &amp; Renewal
      </h2>
      <ul className="SubscriptionLegal__list">
        <li>Your membership is annual and automatically renews each year unless canceled prior.</li>
        <li>We&apos;ll remind you a month before your charge.</li>
        <li>You can manage your membership anytime in your account settings.</li>
        <li>
          Your membership is designed for household use: 1 account holder, up to 2 household
          addresses (for example, home + office, or home + vacation house).
        </li>
      </ul>

      <h2 className="SubscriptionLegal__heading">Cancellation Policy</h2>
      <ul className="SubscriptionLegal__list">
        <li>Cancel within 3 business days with no usage = full refund.</li>
        <li>
          Once you&apos;ve used any benefits (like requesting bags or earning TrashieCash™),
          refunds are no longer available and your membership will be available for the remainder
          of the term.
        </li>
        <li>
          To cancel your renewal, go to your account settings or contact us at
          {' '}
          <a href="mailto:support@trashie.com">support@trashie.com</a>
          .
        </li>
      </ul>

      <p className="SubscriptionLegal__more">
        To learn more,
        {' '}
        <a href={MEMBERSHIP_TERMS_URL} target="_blank" rel="noopener noreferrer">
          view our Terms of service
        </a>
        .
      </p>
    </div>
  </section>
);

export default SubscriptionLegal;
